/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Hero_SubtitleInputs */

const en_features_hero_subtitle = /** @type {(inputs: Features_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening supercharges your reading. Here's how the app works:`)
};

const es_features_hero_subtitle = /** @type {(inputs: Features_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening potencia tu lectura. Así es como funciona la app:`)
};

/**
* | output |
* | --- |
* | "Listening supercharges your reading. Here's how the app works:" |
*
* @param {Features_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_hero_subtitle = /** @type {((inputs?: Features_Hero_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_hero_subtitle(inputs)
	return en_features_hero_subtitle(inputs)
});